import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMap01 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.4719 0.118327C21.797 0.292346 22 0.631206 22 1V17C22 17.3344 21.8329 17.6466 21.5547 17.8321L15.5547 21.8321C15.2395 22.0422 14.8327 22.0562 14.5039 21.8682L8 18.1518L1.49614 21.8682C1.18664 22.0451 0.806388 22.0438 0.498073 21.8649C0.189758 21.686 0 21.3565 0 21V5C0 4.64114 0.192286 4.3098 0.503861 4.13176L7.50386 0.131758C7.81129 -0.0439174 8.18871 -0.0439174 8.49614 0.131758L14.9595 3.82513L20.4453 0.167951C20.7522 -0.0366195 21.1467 -0.0556921 21.4719 0.118327ZM14 5.58032L9 2.72318V16.4197L14 19.2768V5.58032ZM16 19.1315L20 16.4648V2.86852L16 5.53518V19.1315ZM7 16.4197V2.72318L2 5.58032V19.2768L7 16.4197Z",
		fill: "currentColor"
	})
});
export default SvgMap01;
